import {Component, OnInit, AfterViewInit, AfterContentChecked, Input, ElementRef} from '@angular/core';

declare var TiltFx, TweenMax, Power2, Sine;

@Component({
    selector: 'app-img-perspective',
    templateUrl: './img-perspective.component.html',
    styleUrls: ['./img-perspective.component.less']
})
export class ImgPerspectiveComponent implements OnInit, AfterContentChecked, AfterViewInit {
    @Input() imgFixed: string = "";

    animatedElems: any = {
        imgElem: null,
        tiltFxImg: null
    };

    constructor(public elRef: ElementRef) {
    }

    ngOnInit() {
    }

    ngAfterContentChecked() {
        this.animatedElems.imgElem = jQuery('[img-perspective]', this.elRef.nativeElement);
        this.animatedElems.tiltFxImg = jQuery('.tilt-effect', this.elRef.nativeElement);
    }

    ngAfterViewInit() {
        setTimeout(()=> {
            this.initTiltImgEffect();
        }, 10);

        setTimeout(()=> {
            TweenMax.fromTo(this.animatedElems.imgElem, 1.4, {autoAlpha: 0}, {autoAlpha: 1});
        }, 500);
    }

    initTiltImgEffect() {
        new TiltFx(this.animatedElems.tiltFxImg[0], {
            "extraImgs": 3,
            "opacity": 0.6,
            "bgfixed": true,
            "movement": {
                "perspective": 1500,
                "translateX": 10,
                "translateY": 10,
                "translateZ": 2,
                "rotateX": 3,
                "rotateY": 3
            }
        })
    }
}



// WEBPACK FOOTER //
// /Users/davidlagace/Sites/david-lagace-website/src/app/components/img-perspective/img-perspective.component.ts